/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AccountStatus {
    NOT_INVITED = 'NOT_INVITED',
    INIVITED = 'INIVITED',
    ACTIVE = 'ACTIVE',
}
